import $ from 'jquery'
import "@hotwired/turbo-rails"
import { popper }from '@popperjs/core'
import * as bootstrap from 'bootstrap'
import "@nathanvda/cocoon"

// Import Trix and ActionText
import 'trix'
import '@rails/actiontext'

// Make Bootstrap available globally
window.bootstrap = bootstrap
window.$ = $;

import "./controllers"